var Alberta = "แอลเบอร์ตา";
var Manitoba = "มานิโตบา";
var Nunavut = "นูนาวุต";
var Ontario = "ออนแทรีโอ";
var Quebec = "ควิเบก";
var Saskatchewan = "ซัสแคตเชวัน";
var Yukon = "ยูคอน";
var CAStates = {
	Alberta: Alberta,
	"British Columbia": "บริติชโคลัมเบีย",
	Manitoba: Manitoba,
	"New Brunswick": "นิวบรันสวิก",
	"Newfoundland and Labrador": "นิวฟันด์แลนด์และแลบราดอร์",
	"Northwest Territories": "นอร์ทเวสต์เทร์ริทอรีส์",
	"Nova Scotia": "โนวาสโกเชีย",
	Nunavut: Nunavut,
	Ontario: Ontario,
	"Prince Edward Island": "ปรินซ์เอ็ดเวิร์ดไอแลนด์",
	Quebec: Quebec,
	Saskatchewan: Saskatchewan,
	Yukon: Yukon
};

export { Alberta, Manitoba, Nunavut, Ontario, Quebec, Saskatchewan, Yukon, CAStates as default };
